import {USERS_GET_ALL, USER_CREATE, USER_UPDATE, GET_USER} from '../constants';
import baseReducer, {initialState} from './_baseReducer';

export default function reducer(state = initialState, action) {
  return baseReducer(state, action, USERS_GET_ALL, GET_USER, USER_CREATE, USER_UPDATE);
}
